import script from "./ImpersonateAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpersonateAlert.vue?vue&type=script&setup=true&lang=js"

import "./ImpersonateAlert.vue?vue&type=style&index=0&id=cdfaa7d2&lang=scss"

const __exports__ = script;

export default __exports__